module.exports = __webpack_public_path__ + "img/curved-rail-horizontal-right-bottom-backplates-remnants.c5caa960.png";